// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type { BaseResponseTranslateConfigFoundResponse, PostTranslateConfigsBody } from '../types';

/**
 * find
 *
 * @export
 * @tags translate-config-controller
 * @link [GET] /translateConfigs
 */
export function getTranslateConfigs(): Promise<BaseResponseTranslateConfigFoundResponse>;
export function getTranslateConfigs(
    options: ApiOptions<never, never>
): Promise<BaseResponseTranslateConfigFoundResponse>;
export function getTranslateConfigs(
    options?: ApiOptions<never, never>
): Promise<BaseResponseTranslateConfigFoundResponse> {
    return request<never, never, never>('/translateConfigs', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getTranslateConfigs',
    });
}

/**
 * save
 *
 * @export
 * @tags translate-config-controller
 * @link [POST] /translateConfigs
 */
export function postTranslateConfigs(
    data: PostTranslateConfigsBody
): Promise<BaseResponseTranslateConfigFoundResponse>;
export function postTranslateConfigs(
    data: PostTranslateConfigsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseTranslateConfigFoundResponse>;
export function postTranslateConfigs(
    data: PostTranslateConfigsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseTranslateConfigFoundResponse> {
    return request<PostTranslateConfigsBody, never, never>('/translateConfigs', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postTranslateConfigs',
    });
}

export const meta = [
    { tags: ['translate-config-controller'], path: '/translateConfigs', method: 'get' },
    { tags: ['translate-config-controller'], path: '/translateConfigs', method: 'post' },
];
